import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import ClientWallet from '@primusmoney/client_wallet';

import App from './app/react-js-ui/js/app.js';

console.log('loading index.js');

// app config
var EXEC_ENV = 'prod';

App.EXEC_ENV = EXEC_ENV;

var appcore;
var early_messages = [];

var handleMessage = (ev) => {
	if (appcore && appcore.isReady)
		appcore.handleMessage(ev);
	else
		early_messages.push(ev);
}

try {

	// incoming communication for my-widget
	window.addEventListener('message', handleMessage, false);

	// initialize app
	var client_wallet = ClientWallet.getObject();

	if (EXEC_ENV === 'prod')  {
		// suppress logs early, before doing it in App.onLoaded()
		// to avoid all the logs of react_client_wallet.init
		//if (window.simplestore)	window.simplestore.noconsoleoverload = false;

		// could use client_wallet.muteConsoleLog() for version >= 0.30.11

		// Note: when integrated into a CMS we probably don't want to mute logs
	}
	
 	console.log('starting initialization of react client wallet in index.js');
	client_wallet.init()
	.then((res) => {
		if (res) {
			console.log('initialization of client wallet finished in index.js');

			var clientglobal = client_wallet.getGlobalObject();

			if (EXEC_ENV === 'dev')
			clientglobal.setExecutionEnvironment('dev');
			
			appcore = App.getAppObject();

			return appcore.onLoaded();
		}
		else {
			throw new Error('react client wallet did not initialize correctly');
		}
	})
	.then((res) => {
		console.log('app core is now loaded in index.js');

		if (early_messages.length) {
			// empty the list of messages received before appcore being ready
			for (var i = 0; i < early_messages.length; i++) {
				appcore.handleMessage(early_messages[i]); // not serialized, just fired
			}
		}
	})
	.catch((err) => {
		console.log('error initializing react client wallet : ' + err);
	});

}
catch(e) {
	console.log('exception in index.js: ' + e);
	console.log(e.stack);
}
 
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
